<template id="productsIncludes">
<section class="ourProductsIncludes">
  <h2 class="mainHeadingBrands">{{info.res.brands}}</h2>
  <div class="container">
    <div class="row" v-for="cat in cats">
      <div class="col-md-12 col-sm-12">
        <div class="productHeadingBar">
          <h2>{{getCatName(cat)}}</h2>
          <span><img alt="#" src="images/icon-headingbar.png"></span> </div>
      </div>
      <product v-for="product in cat.products" :product="product"/>
    </div>
    <div class="row">
      <div class="col-md-12 col-sm-12 ">
        <div class="warningInfo">
          <div class="warningIcon"><img alt="#" src="images/warning.png" class="warning-icon"><img alt="#" src="images/notification.png" class="notification"></div>
          <div class="warning-text" v-html="info.res.note">This site serves as our distribution business to serve the resellers and bulk purchase customers. We DO NOT sell to individual or general public. For retail sales, please visit SampsonStore.com.</div>
        </div>
      </div>
    </div>
  </div>
</section>
</template>

<script>

import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource);

import product from './Product.vue'

var data = {
  cats:[]
};
export default {
  name: 'productsIncludes',
  props:['name', 'info'],
  data () {
    return data
  },
  components: {
    product
  },
  methods: {
    getCatName:function(cat) {
      var self = this;
      var v = cat.catname;
      if (self.info.res != null) {
        Object.keys(self.info.res).forEach(function(key) {
      //console.log(cat, v, self.info.res, key);
          if (key.indexOf('cat_') == 0) {
            if (self.info.res['cat_'+cat.catname] != null) {
              v = self.info.res['cat_'+cat.catname];
              return v;
            }
          }
        });
      }
      return v;
    }
  },
  mounted: function() {
  },
  created: function() {
    var self = this;
    Object.entries(self.info.res.cats).forEach(([k, v]) => {
      //console.log(k, v);
      data.cats.push(v);
      v['catname'] = k;
    });
    //console.log(data.cats);
    //Vue.http.get('json/cats.json').then(response => {
    //  data.cats = JSON.parse(response.bodyText);
    //}, response => {
    //});
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProductsIncludes.vue